var icon_button_default = {
  "audioIconButton": "bL4Hb"
};
export {
  icon_button_default as default
};
//# sourceMappingURL=icon-button-scss.js.map
